export function roleSelectOptions<R extends string>(
  roles: readonly R[],
  t: (key: string) => string,
): { value: R; label: string }[] {
  return roles.map((role) => ({ value: role, label: t(`common:roles.${role}`) }));
}
